import posthog from 'posthog-js';
import { watch } from 'vue';
import { useAppStore } from '@/stores/app.store';
import { CwxBackend } from '@/types/cwxBackend';

export function usePostHog(): void {
  // Host is fixed in code (PostHog Cloud EU). PostHog is active only when a key
  // is configured in cwxSettings AND an admin has turned the toggle on
  // (System -> Testing Tools). Mirrors the Hotjar enable pattern.
  const apiHost = 'https://eu.i.posthog.com';
  const appStore = useAppStore();
  let initialized = false;

  function initializePostHog(): void {
    if (initialized) {
      return;
    }

    const systemSettings: CwxBackend.ISystemSettingsDto = appStore.systemSettings;
    const apiKey = systemSettings?.postHogApiKey;

    // Toggle off or no key (missing/empty) => do not init PostHog, so it never
    // tracks and disabled customers pay no network cost.
    if (systemSettings?.isPostHogEnabled && apiKey && apiKey.length > 0) {
      posthog.init(apiKey, {
        api_host: apiHost,
        // Config snapshot that enables modern defaults: autocapture, pageviews,
        // session recording, heatmaps and web vitals (required by the ACs).
        // Recording/heatmaps must also be enabled in the PostHog project.
        defaults: '2026-05-30',
      });
      initialized = true;
    }
  }

  watch(
    () => appStore.systemSettings,
    () => {
      initializePostHog();
    },
    // immediate: also init when systemSettings is already populated before this
    // watcher registers (e.g. store prefetch/rehydration), not only on reassignment.
    { immediate: true },
  );
}
